import React, { useContext, createContext, useState,useReducer } from "react";
import { Form, Input, Button } from "antd";
import { Link, useHistory } from "react-router-dom";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { useAuth } from "@/component/Auth";
import styled from "styled-components";
import Checkbox from "antd/lib/checkbox/Checkbox";
import { storage } from "@/util";
import { LOGININFOSTORE, LOGINTOKEN } from "@/config/const";
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
//import useRtm from "@/hooks/use-rtm";
import isElectron from "is-electron";
import {useRTM} from "@/component/Rtm";

const Container = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  flex-direction: column;
  .atitle {
    display: flex;
    width: 100%;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    margin-top: 60px;
    height: 80px;
    justify-content: center;
    .fir {
      margin-right: 20px;
    }
    .active {
      color: red;
      cursor: default;
    }
  }
  .ap {
    position: fixed;
    right: 0;
    bottom: 0;
    width: 100wh;
    height: 30px;
  }
`;

const Login = () => {
  // const rtm = useRtm({}, (closedByServer)=>{
  //   console.log("[Login] closedByServer", closedByServer);
  //   //关闭rtm
  //   rtm.logout();
  //   //退出登录
  //   storage.remove(LOGININFOSTORE);
  //   storage.remove(LOGINTOKEN);
  //   if (isElectron()) {
  //     alert(`推出登陆!`);
  //     history.replace("/");
  //   } else {
  //     window.location.href = "/";
  //   }
  //   alert("检测到相同账号重复登录，已自动退出!");
  // });
  const [autoLogin, setAutoLogin] = useState(false);

  const history = useHistory();
  const auth = useAuth();
  const [form] = Form.useForm();
  const {connectRTM} = useRTM();

  const handleSubmit = async (values: any) => {
    auth.login(values, async () => {
      await connectRTM();
      history.replace("/");
    });
  };

  const [isUserLogin, setIsUserLogin] = React.useState(true);

  const aset = (username: string) => {
    form.setFieldsValue({
      username,
      password: "123456",
    });
  };
  // 在组件挂载时，从localStorage中获取autoLogin的值
  React.useEffect(() => {
    const savedAutoLogin = localStorage.getItem('autoLogin');
    setAutoLogin(savedAutoLogin === 'true');
  }, []);
   // 当用户选择或取消选择自动登录时，将新的值保存到localStorage
   const handleAutoLoginChange = (e:CheckboxChangeEvent) => {
     
    const newAutoLogin = e.target.checked;
    setAutoLogin(newAutoLogin);
    localStorage.setItem('autoLogin', String(newAutoLogin));
    console.log("remember auto login or not:"+localStorage.getItem("autoLogin"))
  };

  React.useEffect(() => {
    const info = storage.get(LOGININFOSTORE);
    if (info.userId) {
      auth.updateLogInfo(info);
      history.replace("/login");
    }
  }, []);

  return (
    <Container>
      <div className="atitle">
        <span
          className={isUserLogin ? "active fir" : "fir"}
          onClick={() => setIsUserLogin(true)}
        >
          登录
        </span>
        {/* <span
          className={!isUserLogin ? "active" : ""}
          onClick={() => setIsUserLogin(false)}
        >
          企业登录
        </span> */}
      </div>
      <Form onFinish={handleSubmit} form={form}>
        <Form.Item
          name="username"
          rules={[{ required: true, message: "用户名不能为空" }]}
          // initialValue={"18611385915"}
        >
          <Input prefix={<UserOutlined />} placeholder="请输入用户名" />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[{ required: true, message: "密码不能为空" }]}
          // initialValue={"123456"}
        >
          <Input
            prefix={<LockOutlined />}
            type="password"
            placeholder="请输入密码"
          />
        </Form.Item>
        <div className="jssb">
        <Checkbox checked={autoLogin} onChange={handleAutoLoginChange}>自动登录</Checkbox>
          <Link to="/losepass">忘记密码?</Link>
        </div>

        <Button type="primary" htmlType="submit" block className="mt25"  >
          登录
        </Button>
        <div className="mt10 jsc">
          <Link to="/register">注册账号</Link>
        </div>
      </Form>
      <div className="ap">
        <Button size="small" onClick={() => aset("18633931685")}>
          18633931685
        </Button>
        <Button
          size="small"
          className="ml20"
          onClick={() => aset("18611385915")}
        >
          18611385915
        </Button>
        <Button
          size="small"
          className="ml20"
          onClick={() => aset("17600577653")}
        >
          17600577653
        </Button>
      </div>
    </Container>
  );
};

export default Login;
